import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog as MuiDialog,
  TextField,
  Typography,
} from '@mui/material';
import React, { FunctionComponent } from 'react';

import { useSuperLikeDialog } from './useSuperLikeDialog';

interface SuperLikeDialogProps {
  open: boolean;
  onClose: () => void;
  eventId: string;
  userId: string;
  maxSuperLikes: number;
}

export const SuperLikeDialog: FunctionComponent<SuperLikeDialogProps> = ({
  open,
  onClose,
  eventId,
  userId,
  maxSuperLikes,
}) => {
  const { onSubmit, register, errors } = useSuperLikeDialog({
    eventId,
    userId,
    onClose,
    defaultMaxSuperLikes: maxSuperLikes,
  });
  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Modifier le nombre de super likes
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          required
          margin="dense"
          id="maxSuperLikes"
          label="Super likes"
          type="number"
          fullWidth
          {...register('maxSuperLikes')}
          helperText={
            errors.maxSuperLikes?.message ? (
              <Typography component="p" variant="body2" color="error.main">
                {errors.maxSuperLikes.message}
              </Typography>
            ) : null
          }
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annuler</Button>
        <Button onClick={onSubmit}>Valider</Button>
      </DialogActions>
    </MuiDialog>
  );
};
